export const environment = {
  production: true,
  envName: 'prod',

  // SSO Domain
  ssoDomain: 'gast.de',

  // gast service // DEPRECATED REMOVE LATER this url is defined in gast-common //TODO
  authServiceUrl: 'https://api.gast.de/auth/',

  // tao portal
  taoPortalUrl: `http://tao.testas.de/tao/Main/login`,

  // google recaptcha
  googleRecaptchaKeySite: '6LeXpbMUAAAAANqJJe53TE8mdeiZ8DX4Mf3jqebI'
};
